module.exports = __webpack_public_path__ + "img/slide-2.04db5fbd.jpg";